// Универсальный тип контактной информации для использования в разных местах
export interface ContactInfoDto {
  workEmail?: string;
  phone?: string;
  facebook?: string;
  instagram?: string;
  twitter?: string;
  telegram?: string;
  website?: string;
}

// Проверка, есть ли хоть одно заполненное поле
export const hasAnyContactInfo = (contactInfo?: ContactInfoDto): boolean => {
  if (!contactInfo) return false;
  return !!(
    contactInfo.workEmail ||
    contactInfo.phone ||
    contactInfo.facebook ||
    contactInfo.instagram ||
    contactInfo.twitter ||
    contactInfo.telegram ||
    contactInfo.website
  );
};
